export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.5 3a2 2 0 012 2v2h4a2 2 0 012 2v10a2 2 0 01-2 2h-17a2 2 0 01-2-2V9a2 2 0 012-2h4V5a2 2 0 012-2h5zm-11 16h17V9h-17v10zm6-12h5V5h-5v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};